import { ReactNode } from 'react';

export interface IconButtonV2Props {
    icon: ReactNode;
    size?: 'sm' | 'md';
    textColor?: keyof typeof textColorOptions;
    bgColor?: keyof typeof bgColorOptions;
    hasborder?: boolean;
    bordercolor?: keyof typeof borderColorOptions;
    disabled?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    showLoader?: boolean;
    title?: string;
    className?: string;
    type?: 'button' | 'submit' | 'reset';
    form?: string;
    dataElement?: string;
}

export interface DefaultButtonV2Props {
    buttonText: string;
    children?: ReactNode;
    icon?:
        | 'plus'
        | 'minus'
        | 'exclamation'
        | 'download'
        | 'parking'
        | 'angleRight'
        | 'trash';
    iconSize?: number;
    textColor?: keyof typeof textColorOptions;
    bgColor?: keyof typeof bgColorOptions;
    hasborder?: boolean;
    textSize?: 'text-xs' | 'text-sm' | 'text-base' | 'text-lg';
    bordercolor?: keyof typeof borderColorOptions;
    padding?: boolean;
    disabled?: boolean;
    marginLeft?: boolean;
    marginRight?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    showLoader?: boolean;
    Request?: boolean;
    title?: string;
    className?: string;
    isTabStyle?: boolean;
    isActiveTab?: boolean;
    type?: 'button' | 'submit' | 'reset';
    form?: string;
    small?: boolean;
    fullWidth?: boolean;
    endIcon?: React.ReactNode;
    dataElement?: string;
}

export const bgColorOptions = {
    blue: 'bg-pk-blue hover:opacity-90 focus-visible:ring-pk-blue',
    lightBlue:
        'bg-pk-light-blue hover:opacity-90 focus-visible:ring-pk-light-blue',
    white: 'bg-white hover:opacity-90 focus-visible:ring-pk-light-gray',
    teal: 'bg-pk-teal hover:bg-pk-dark-blue hover:opacity-90 focus-visible:ring-pk-teal',
    red: 'bg-pk-red hover:opacity-90 focus-visible:ring-pk-red',
    brand: 'bg-pk-oparko-dark-blue hover:bg-pk-teal hover:opacity-90 focus-visible:ring-pk-oparko-dark-blue',
};

export const textColorOptions = {
    white: 'text-white',
    black: 'text-black',
    gray: 'text-pk-dark-gray',
    lightgray: 'text-pk-light-grey',
    blue: 'text-pk-blue',
    red: 'text-pk-red',
    darkgray: 'pk-dark-gray',
};

export const borderColorOptions = {
    gray: 'border-pk-gray',
    lightgray: 'border-pk-light-grey',
};
